import React, { createContext, useState, useContext } from "react";

type Direction = "left" | "right" | "none";

interface NavigationContextType {
  direction: Direction;
  setDirection: (direction: Direction) => void;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
}

const NavigationContext = createContext<NavigationContextType>({
  direction: "none",
  setDirection: () => {},
  currentTab: "home",
  setCurrentTab: () => {},
});

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [direction, setDirection] = useState<Direction>("none");
  const [currentTab, setCurrentTab] = useState("home");

  return (
    <NavigationContext.Provider
      value={{ direction, setDirection, currentTab, setCurrentTab }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
